// extracted by mini-css-extract-plugin
module.exports = {"constrain":"Paragraph_constrain__Q14RT","centered":"Paragraph_centered__1xTQ6","bold":"Paragraph_bold__1H4gm"};